import z from "zod";
import { cn } from "@/lib/utils";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { CheckIcon, Loader2Icon } from "lucide-react";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { toFormikValidationSchema } from "zod-formik-adapter";

import { Button } from "../ui/button";
import TaskComment from "./taskComment";
import UserAvatar from "../ui/userAvatar";
import InputText from "../common/InputText";
import TaskAttachment from "./taskAttachment";
import TaskDependencies from "./taskDependencies";
import ErrorMessage from "../common/ErrorMessage";
import { Popover, PopoverTrigger, PopoverContent } from "../ui/popover";
import {
  createTaskSchema,
  milestoneTaskSchema,
} from "../../../../backend/src/schemas/taskSchema";
import { Calendar } from "@/components/ui/calendar";

import { useUser } from "@/hooks/useUser";
import useTaskQuery from "@/api/query/useTaskQuery";
import dateFormater from "@/helperFuntions/dateFormater";
import useTaskAddMembersMutation from "@/api/mutation/useTaskAddMember";
import useTaskMemberListQuery from "@/api/query/useTaskMemberListQuary";
import useCreateTaskMutation, {
  Task,
} from "@/api/mutation/useTaskCreateMutation";
import useUpdateTaskMutation from "@/api/mutation/useTaskUpdateMutation";
import useRemoveTaskMemberMutation from "@/api/mutation/useTaskRemoveMember";
import { UserOrganisationType } from "@/api/query/useOrganisationDetailsQuery";
import useTaskAttechmentAddMutation from "@/api/mutation/useTaskAttechmentAddMutation";
import useTaskAddUpdateMilestoneMutation from "@/api/mutation/useTaskAddUpdateMilestone";
import useAllTaskQuery from "@/api/query/useAllTaskQuery";

import PlusSvg from "../../assets/svg/Plus.svg";
import Edit from "../../assets/svg/NewEditIcon.svg";
import TrashCan from "../../assets/svg/TrashCan.svg";
import YallowInfoIcon from "@/assets/svg/YallowInfoIcon.svg";
import Close from "../../assets/svg/CrossIcon.svg";
import PapperClip from "../../assets/svg/Paperclip.svg";
import InfoCircle from "../../assets/svg/Info circle.svg";
import BackIcon from "../../assets/svg/NewLetsIconsBack.svg";
import CalendarIcon from "../../assets/svg/newCalendarIcon.svg";
import ScaleSvg from "../../assets/svg/ScaleSvg.svg";
import DesktopSvg from "../../assets/svg/Desktop.svg";
import DropboxSvg from "../../assets/svg/Dropbox.svg";
import InputNumber from "@/components/common/InputNumber";
import TaskHistory from "./taskHistory";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import {
  TaskDependenciesEnumValue,
  TaskStatusEnumValue,
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import useTaskStatusUpdateMutation from "@/api/mutation/useTaskStatusUpdateMutation";
import useProjectQuery from "@/api/query/useProjectQuery";
import { Slider } from "../ui/slider";
import Loader from "../common/Loader";
import useAllKanbanColumnQuery from "@/api/query/useAllKanbanColumn";
import Dialog from "../common/Dialog";
import useRemoveTaskDependenciesMutation from "@/api/mutation/useTaskRemoveDependencies";

import RedFlag from "@/assets/svg/RedFlag.svg";
import OrangeFlag from "@/assets/svg/OrangeFlag.svg";
import GreenFlag from "@/assets/svg/GreenFlag.svg";
import PercentageCircle from "../shared/PercentageCircle";
import ParentTaskIcon from "@/assets/svg/ParentTaskIcon.svg";
import NoramlPlus from "@/assets/svg/NoramlPlus.svg";
import { errorConfig } from "@/lib/toastError";
import { generateUniqueTaskName } from "../shared/taskNameGenrater";
import { useTranslation } from "react-i18next";
import { OrgListOfNonWorkingDaysEnum } from "@backend/src/schemas/organisationSchema";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import { debounce } from "lodash";
import OverlaySlider from "../SlidingOverlay";
import "./task.css";
import { appUrl, msalClientId } from "@/Environment";
import useSharePointAttechmentAddMutation from "@/api/mutation/useSharePointAttechmentMutaion";
import useProjectDetail from "@/api/query/useProjectDetailQuery";
import MemberAssignmentItem from "./taskAssignmentItem";
import useUpdateTaskMemberMutation from "@/api/mutation/useAssignTaskMemeberUpdateMutation";
import { Link } from "react-router-dom";
import useDebounce from "@/hooks/useDebounce";
import useRemoveTaskMutation from "@/api/mutation/useTaskRemove";
import useUpdateTaskParentMutation from "@/api/mutation/useTaskParentUpdateMutation";
declare global {
  interface Window {
    OneDrive: any;
  }
}
type Props = {
  projectId: string | undefined;
  taskId?: string | undefined;
  close: (data: string) => void;
  initialValues?: { startDate: Date | undefined; taskId?: string };
  createSubtask?: string;
};

function TaskSubTaskForm(props: Props) {
  let tempId = "";
  const { t } = useTranslation();
  const currantUser = useUser();
  const [subTask, setSubtask] = useState("");
  const [errorMessage, setErrorMesage] = useState("");
  const [updateDate, setUpdateDate] = useState<Date>();
  const fileInput = useRef<HTMLInputElement>(null);
  const [taskNameField, setTaskNameField] = useState(false);
  const [taskDurationField, setTaskDurationField] = useState(false);
  const [taskId, setTaskId] = useState<string>(props.taskId ?? "");
  const [subTaskFieldShow, setSubTaskFieldShow] = useState<boolean>(false);
  const [member, setMambers] = useState<UserOrganisationType["user"][]>([]);
  const [attachmentUploading, setAttachmentUploading] =
    useState<boolean>(false);
  const taskQuery = useTaskQuery(taskId, true);
  const taskMemberList = useTaskMemberListQuery(props.projectId ?? "");
  const taskUpdateMutation = useUpdateTaskMutation(taskId);
  const updateTaskParentMutation = useUpdateTaskParentMutation();
  const taskRemoveMembersMutation = useRemoveTaskMemberMutation();
  const taskAddMembersMutation = useTaskAddMembersMutation(taskId);
  // let tasks =
  //   taskQuery.data?.data.data && taskId ? taskQuery.data?.data.data : undefined;
  const [task, setTask] = useState(
    taskQuery.data?.data.data && taskId ? taskQuery.data?.data.data : undefined
  );
  const [slider, setSlider] = useState(Number(task?.completionPecentage));
  const taskAttachmentAddMutation = useTaskAttechmentAddMutation(taskId);
  const [invalidDate, setInvalidDate] = useState<boolean>(false);
  const removeTaskDependenciesMutation = useRemoveTaskDependenciesMutation();
  const taskCreateMutation = useCreateTaskMutation(
    props.projectId,
    props.createSubtask ? props.createSubtask : taskId ? taskId : ""
  );
  const sharePointAttechmentAddMutation =
    useSharePointAttechmentAddMutation(taskId);
  const [endDate, setEndDate] = useState<Date>();

  const taskAddUpdateMilestoneMutation =
    useTaskAddUpdateMilestoneMutation(taskId);
  const allKanbanColumn = useAllKanbanColumnQuery(props.projectId);
  useEffect(() => {
    if (taskQuery.status == "success") {
      setSlider(Number(taskQuery.data?.data.data?.completionPecentage));
    }
    setTask(taskQuery.data?.data.data);
  }, [taskQuery.data?.data.data, taskQuery.status]);
  // const [submitbyButton, setSubmitbyButton] = useState(false);

  const projects = useProjectQuery();
  const user = useUser();
  const [startDate, setStartDate] = useState<Date>(new Date());
  const [parentTask, setParentTask] = useState<string>();
  const allTask = useAllTaskQuery(props.projectId, false);
  const ProjectDetail = useProjectDetail(props.projectId, false);
  useEffect(() => {
    setTask(taskQuery.data?.data.data);
    allTask.refetch();
  }, [taskId, taskQuery.data]);

  useEffect(() => {
    if (taskId && task) {
      taskFormik.setValues({
        taskName: task.taskName,
        taskDescription: task.taskDescription ?? "",
        startDate: task.startDate,
        duration: task.duration,
      });
      milestoneFormik.setValues({
        milestoneIndicator: task.milestoneIndicator,
      });
      setMambers(
        task.assignedUsers.map((u) => {
          return u.user;
        })
      );
    }

    setParentTask(
      allTask.data?.data.data.find(
        (t) => t.taskId == (task?.parentTaskId ?? props.createSubtask)
      )?.taskName
    );

    if (
      allKanbanColumn.data?.data.data &&
      allKanbanColumn.data?.data.data.length <= 1 &&
      !task
    ) {
      const id = allKanbanColumn.data.data.data[0]?.kanbanColumnId;
      const updatedValues = { ...taskFormik.values, kanbanColumnId: id };
      taskFormik.setValues(updatedValues);
    }
    if (projects.data?.data.data) {
      setStartDate(
        new Date(
          projects.data?.data.data.find((p) => p.projectId == props.projectId)
            ?.startDate ?? new Date()
        )
      );
    }
    const endDate = task ? task.endDate : new Date();
    setEndDate(new Date(endDate));
  }, [task]);

  const allowed = () => {
    const project = projects.data?.data.data.find(
      (p) => p.projectId == props.projectId
    );
    if (!taskId) {
      return true;
    }
    if (
      user.user?.userOrganisation[0]?.role === UserRoleEnumValue.ADMINISTRATOR
    ) {
      return true;
    } else if (
      task?.assignedUsers.find((u) => u.user.userId === user.user?.userId) ||
      task?.createdByUserId == user.user?.userId
    ) {
      return true;
    } else if (
      project?.assignedUsers.find(
        (u) =>
          u.user.userId == user.user?.userId &&
          u.projectRole == UserRoleEnumValue.PROJECT_MANAGER
      )
    ) {
      return true;
    }
    return false;
  };

  const taskFormik = useFormik<z.infer<typeof createTaskSchema>>({
    initialValues: {
      taskName: "",
      taskDescription: "",
      startDate: new Date(),
      duration: 1 as unknown as number,
    },
    validationSchema: toFormikValidationSchema(createTaskSchema),
    onSubmit: (values) => {
      if (taskId || tempId) {
        if (
          values.duration !== task?.duration ||
          values.startDate !== task?.startDate ||
          values.taskDescription !== task.taskDescription ||
          values.taskName !== task.taskName
        ) {
          let data;
          if (values.duration === task?.duration) {
            data = {
              taskName: values.taskName,
              startDate: values.startDate,
              taskDescription: values.taskDescription,
            };
          } else {
            data = values;
          }
          taskUpdateMutation.mutate(data, {
            onSuccess() {
              // toast.success(data.data.message);
              // if (submitbyButton) {
              //   props.close();
              // }
              refetch();
            },
            onError(error) {
              if (
                error.response?.data.message?.includes(
                  "Would you like to remove the dependency?"
                )
              ) {
                setErrorMesage(error.response?.data.message);
                setInvalidDate(true);
                refetch();
              } else {
                refetch();
                toast.error(
                  error.response?.data.message == "Unauthorized"
                    ? t(
                        "You are not authorized to edit tasks which are not assigned to you"
                      )
                    : errorKeyFormate(error.response?.data.message + ""),
                  errorConfig
                );
              }
            },
          });
        }
      } else {
        if (props.initialValues?.startDate) {
          values.startDate = new Date(props.initialValues?.startDate);
        }
        values.startDate.setUTCHours(0, 0, 0, 0);
        taskCreateMutation.mutate(values, {
          onSuccess(data) {
            refetch();
            setTaskId(data.data.data.taskId);
            // toast.success(data.data.message);
            // projects.refetch();
          },
          onError(error) {
            refetch();
            toast.error(
              errorKeyFormate(error.response?.data.message + ""),
              errorConfig
            );
          },
        });
      }
    },
  });
  console.log(taskFormik.errors);
  
  useEffect(() => {
    if (!taskId) {
      const parentTaskDate = allTask.data?.data?.data.find(
        (t) => t.taskId === (task?.parentTaskId ?? props.createSubtask)
      )?.startDate;

      const initialStartDate = props.initialValues?.startDate;
      const project = projects?.data?.data?.data.find(
        (p) => p.projectId === props.projectId
      );
      const projectStartDate = project?.startDate;

      let date = new Date();
      if (initialStartDate) {
        date = new Date(initialStartDate);
      } else if (projectStartDate) {
        const projectDate = new Date(projectStartDate);
        date = projectDate >= new Date() ? projectDate : new Date();
      }

      if (parentTaskDate) {
        date = new Date(parentTaskDate);
      }

      taskFormik.setFieldValue("startDate", date);
    }
  }, [
    taskId,
    task?.parentTaskId,
    props.createSubtask,
    props.initialValues?.startDate,
    props.projectId,
    projects?.data?.data?.data,
    allTask.data?.data?.data,
  ]);

  const milestoneFormik = useFormik<z.infer<typeof milestoneTaskSchema>>({
    initialValues: {
      milestoneIndicator: false,
    },
    validationSchema: toFormikValidationSchema(milestoneTaskSchema),
    onSubmit: (values) => {
      milestoneSubmit(values);
    },
  });
  const milestoneSubmit = async (
    values: z.infer<typeof milestoneTaskSchema>
  ) => {
    if (!taskId && !taskCreateMutation.isPending) {
      await createTaskWithValue()?.then(() => {
        taskAddUpdateMilestoneMutation.mutate(
          { ...values, taskId: tempId },
          {
            onSuccess() {
              refetch();
            },
            onError(error) {
              toast.error(
                errorKeyFormate(error.response?.data.message + ""),
                errorConfig
              );
            },
          }
        );
      });
    }
    if (taskId) {
      taskAddUpdateMilestoneMutation.mutate(
        { ...values, taskId: tempId },
        {
          onSuccess() {
            refetch();
          },
          onError(error) {
            toast.error(
              errorKeyFormate(error.response?.data.message + ""),
              errorConfig
            );
          },
        }
      );
    }
    // Ensuring taskId is set before mutating
  };
  const milestoneHandlechange = (e: boolean) => {
    milestoneFormik.setFieldValue("milestoneIndicator", e);
    if (!e) {
      milestoneSubmit({ milestoneIndicator: false });
    }
  };

  const createSubTask = async () => {
    let value: {
      taskName: string;
      taskDescription: string;
      startDate: Date;
      duration: number;
      assginedToUserId: string[];
      milestoneIndicator: boolean;
      tempId?: string;
    } = {
      taskName: subTask,
      taskDescription: "",
      startDate: task?.startDate ?? new Date(),
      duration: 1,
      assginedToUserId: [currantUser.user?.userId ?? ""],
      milestoneIndicator: false,
    };
    if (!taskId) {
      await createTaskWithValue();
      value = { ...value, tempId };
    }
    taskCreateMutation.mutate(value, {
      onSuccess() {
        refetch();
        setSubtask("");
        setSubTaskFieldShow((prev) => (prev = !prev));
        // toast.success(data.data.message);
      },
      onError(error) {
        toast.error(
          errorKeyFormate(errorKeyFormate(error.response?.data.message + "")),
          errorConfig
        );
      },
    });
  };

  const refetch = () => {
    taskQuery.refetch();
  };

  const handleToggleMember = useCallback(
    debounce((data: UserOrganisationType, workingHours?: number) => {
      if (
        !taskQuery.isFetching &&
        !taskQuery.isRefetching &&
        !taskMemberList.isFetching &&
        !taskMemberList.isRefetching &&
        !taskAddMembersMutation.isPending &&
        !taskRemoveMembersMutation.isPending
      ) {
        const userExists = task?.assignedUsers?.some(
          (u) => u.user.userId == data.user.userId
        );

        if (userExists) {
          const idToRemove =
            task?.assignedUsers.find((id) => id.user.userId == data.user.userId)
              ?.taskAssignUsersId ?? "";

          removeMembers(idToRemove);
        } else {
          submitMembers(data, workingHours ?? 8);
        }
      }
    }, 500),
    [
      taskAddMembersMutation,
      taskRemoveMembersMutation,
      taskQuery,
      task,
      taskMemberList.data?.data.data,
    ]
  );

  const submitMembers = async (
    user: UserOrganisationType,
    workingHours: number
  ) => {
    if (!taskId) {
      await createTaskWithValue();
    }
    if (user) {
      taskAddMembersMutation.mutate(
        {
          assginedToUserId: user.user.userId,
          workingHours: workingHours,
          taskId: tempId ? tempId : taskId,
        },
        {
          onSuccess() {
            refetch();
            setMambers((prev) => [...prev, user.user]);
            projects.refetch();
          },
          onError(error) {
            toast.error(
              errorKeyFormate(error.response?.data.message + ""),
              errorConfig
            );
          },
        }
      );
    }
  };

  const removeMembers = (id: string) => {
    taskRemoveMembersMutation.mutate(id, {
      onSuccess() {
        refetch();
        // toast.success(data.data.message);
        projects.refetch();
      },
      onError(error) {
        toast.error(
          errorKeyFormate(error.response?.data.message + ""),
          errorConfig
        );
      },
    });
  };
  const [showConfirmDelete, setShowConfirmDelete] = useState<string | null>(
    null
  );
  const removeTaskMutation = useRemoveTaskMutation();
  const removeTask = () => {
    if (showConfirmDelete) {
      removeTaskMutation.mutate(showConfirmDelete, {
        onSuccess(data) {
          setShowConfirmDelete(null);
          taskQuery.refetch();
          toast.success(data.data.message);
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      });
    }
  };
  const nonWorkingDays = () => {
    const nWd =
      user?.user?.userOrganisation.map(
        (org) => org.organisation.nonWorkingDays
      ) || [];
    const mapDayToNumber = (day: OrgListOfNonWorkingDaysEnum) => {
      switch (day) {
        case "SUN":
          return 0;
        case "MON":
          return 1;
        case "TUE":
          return 2;
        case "WED":
          return 3;
        case "THU":
          return 4;
        case "FRI":
          return 5;
        case "SAT":
          return 6;
        default:
          return 0;
      }
    };
    const result: number[] = [];
    nWd.forEach((days) => {
      days.forEach((day) => {
        result.push(mapDayToNumber(day));
      });
    });
    return result;
  };
  const fileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!taskId) {
      await createTaskWithValue();
    }
    if ((taskId || tempId) && e.target.files?.length) {
      setAttachmentUploading(true);
      const formData = new FormData();
      for (let i = 0; i < e.target.files.length; ++i) {
        formData.append("taskAttachment", e.target.files[i]);
      }
      taskAttachmentAddMutation.mutate(
        { FormData: formData, tempId: tempId },
        {
          onSuccess() {
            refetch();
            // toast.success(data.data.message);
            setAttachmentUploading(false);
          },
          onError(error) {
            toast.error(
              errorKeyFormate(error.response?.data.message + ""),
              errorConfig
            );
            setAttachmentUploading(false);
          },
        }
      );
    }
    setOpen(false);
  };
  const [progressError, setProgressError] = useState("");
  const [scheduledError, setScheduledError] = useState(false);
  const onProgressUpdate = async (e: number[]) => {
    if (!taskId) {
      await createTaskWithValue();
    }
    const val = e[0];

    // If task starts in the future, block the update
    const today = new Date();
    const todayDateOnly = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );

    const startDate = new Date(task?.startDate ?? "");
    const startDateOnly = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate()
    );

    // If task starts in the future, block the update
    if (startDateOnly > todayDateOnly) {
      console.log("call");
      setScheduledError(true);

      return;
    }
    if (
      Number(val) !== Number(task?.completionPecentage) &&
      !taskCreateMutation.isPending
    ) {
      if (Number(val) > 100 || Number(val) < 0) {
        setProgressError("Progress must be within the range of 0 to 100.");
      } else {
        setProgressError("");
        taskUpdateMutation.mutate(
          {
            completionPecentage: Number(val) ?? 0,
            kanbanColumnId: "",
            id: tempId,
          },
          {
            onSuccess() {
              refetch();
            },
            onError(error) {
              toast.error(
                error.response?.data.message == "Unauthorized"
                  ? t(
                      "You are not authorized to edit tasks which are not assigned to you"
                    )
                  : errorKeyFormate(error.response?.data.message + ""),
                errorConfig
              );
            },
          }
        );
      }
    }
  };
  const taskStatusUpdateMutation = useTaskStatusUpdateMutation(taskId);
  const updateStatus = async (status: string) => {
    const today = new Date();
    const todayDateOnly = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );

    const startDate = new Date(task?.startDate ?? "");
    const startDateOnly = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate()
    );

    // If task starts in the future, block the update
    if (startDateOnly > todayDateOnly) {
      setScheduledError(true);

      return;
    }
    if (!taskId) {
      await createTaskWithValue();
    }

    taskStatusUpdateMutation.mutate(
      { status, taskId: tempId },
      {
        onSuccess() {
          refetch();
        },
        onError(error) {
          toast.error(
            error.response?.data.message == "Unauthorized"
              ? t(
                  "You are not authorized to edit tasks which are not assigned to you"
                )
              : errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      }
    );
  };
  const taskStatus = () => {
    const removeStatus = [TaskStatusEnumValue.IN_PROGRESS];
    if (task?.milestoneIndicator) {
      return Object.keys(TaskStatusEnumValue).filter(
        (e) => !removeStatus?.some((r) => e === r)
      );
    } else {
      return Object.keys(TaskStatusEnumValue);
    }
  };
  const close = () => {
    setTask(undefined);
    if (taskId) {
      allTask.refetch();
    }
    props.close(taskId);
  };
  const deleteDependenciesId = () => {
    const taskDependenciesId = taskQuery?.data?.data.data.dependencies?.find(
      (item) =>
        item.dependentTaskId === taskQuery.data?.data.data.taskId &&
        item.dependentType === TaskDependenciesEnumValue.PREDECESSORS
    )?.taskDependenciesId;
    if (taskDependenciesId) {
      removeTaskDependenciesMutation.mutate(taskDependenciesId, {
        onSuccess(data) {
          refetch();
          taskUpdateMutation.mutate(
            { startDate: updateDate },
            {
              onSuccess() {
                refetch();
              },
            }
          );
          toast.success(data.data.message);
          setInvalidDate(false);
        },
        onError(error) {
          toast.error(
            error.response?.data.message == "Unauthorized"
              ? t(
                  "You are not authorized to edit tasks which are not assigned to you"
                )
              : errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
          setInvalidDate(false);
        },
      });
    }
  };
  const [showAllSubTitle, setShowAllSubTitle] = useState(false);

  const createTaskWithValue = (value?: {
    startDate?: Date;
    taskDescription?: string;
    duration?: number;
  }) => {
    if (taskCreateMutation.isPending && !taskId) {
      return;
    }
    const project = projects?.data?.data?.data.find(
      (p) => p.projectId === props.projectId
    );

    const data = {
      taskName: generateUniqueTaskName(
        allTask.data?.data.data ?? [],
        project?.projectName ?? ""
      ),
      taskDescription: value?.taskDescription,
      startDate: UTCDateConverter(
        value?.startDate
          ? new Date(value.startDate)
          : taskFormik.values.startDate
      ),
      duration: value?.duration ?? 1,
    };
    return new Promise<void>((resolve, reject) => {
      taskCreateMutation.mutate(data, {
        onSuccess(res) {
          setTaskId(res.data.data.taskId);
          setTask(res.data.data);
          tempId = res.data.data.taskId;
          resolve();
        },
        onError(error) {
          refetch();
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
          reject(error);
        },
      });
    });
  };

  const holiday = user.user?.userOrganisation[0].organisation.orgHolidays?.map(
    (t) => new Date(t.holidayStartDate)
  );

  const getSelectedDate = useCallback(() => {
    const date = taskFormik.values.startDate
      ? new Date(taskFormik.values.startDate)
      : new Date(startDate);
    if (isNaN(date.getTime())) {
      return new Date(); // Fallback to current date if invalid
    }
    date.setHours(0, 0, 0, 0);
    return date;
  }, [startDate, taskFormik.values.startDate]);
  const UTCDateConverter = (date: Date) => {
    return new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
    );
  };
  function calculateDurations(startDate: Date, endDate: Date): number {
    const start = UTCDateConverter(new Date(startDate));
    const end = UTCDateConverter(new Date(endDate));

    // Include end date in calculation (add 1 day)
    end.setDate(end.getDate() + 1);

    const excludedDays = nonWorkingDays(); // e.g., [0, 6] for SUN, SAT

    const holidays =
      user?.user?.userOrganisation?.[0]?.organisation?.orgHolidays?.map((h) =>
        dateFormater(new Date(h.holidayStartDate))
      ) ?? [];

    let duration = 0;

    for (let d = new Date(start); d < end; d.setDate(d.getDate() + 1)) {
      const day = d.getDay();
      const formattedDate = d.toISOString().split("T")[0];

      if (
        !excludedDays.includes(day) &&
        !holidays.includes(dateFormater(new Date(formattedDate)))
      ) {
        duration++;
      }
    }

    return duration;
  }

  // components/SharePointPicker.tsx

  const openPicker = () => {
    const odOptions = {
      clientId: msalClientId, // From Azure Portal
      action: "download", // or "query", "share" etc.
      multiSelect: true,
      oauth2AllowIdTokenImplicitFlow: true,
      advanced: {
        redirectUri: appUrl, // Must match Azure app registration
        // optional: restrict to business accounts
        openInNewWindow: true,
        queryParameters: "select=id,name,size,file,webUrl",
      },
      cache: {
        cacheLocation: "localStorage",
      },
      success: async function (files: any) {
        if (!taskId) {
          await createTaskWithValue();
        }
        const data = {
          file: files.value.map((f: any) => {
            return {
              name: f.name,
              url: f.webUrl,
            };
          }),
          tempId: tempId,
        };
        sharePointAttechmentAddMutation.mutate(data, {
          onSuccess() {
            refetch();
            // toast.success(data.data.message);
            setAttachmentUploading(false);
          },
          onError(error) {
            toast.error(
              errorKeyFormate(error.response?.data.message + ""),
              errorConfig
            );
            setAttachmentUploading(false);
          },
        });
        setOpen(false);
      },
      cancel: function () {
        console.log("User cancelled the picker.");
      },
      error: function (e: any) {
        console.error("Picker error:", e);
      },
    };
    window.OneDrive.open(odOptions);
  };
  const [open, setOpen] = useState(false);
  const [taskMember, setTaskMember] = useState<UserOrganisationType[]>([]);
  const setMember = () => {
    const members = taskMemberList.data?.data.data ?? [];
    const assignedUsers = ProjectDetail.data?.data.data.assignedUsers ?? [];

    const filtered = members.filter(
      (t) =>
        !assignedUsers.find(
          (u) =>
            u.projectRole === UserRoleEnumValue.COLLABORATOR &&
            u.user.userId === t.user.userId
        )
    );

    setTaskMember(filtered);
  };
  useEffect(() => {
    setMember();
  }, [
    taskMemberList.data?.data.data,
    ProjectDetail.data?.data.data.assignedUsers,
  ]);
  const updateTaskMemberMutation = useUpdateTaskMemberMutation();
  const handleUpdateMemberAssignment = (
    member: UserOrganisationType,
    workingHours: number
  ) => {
    if (!taskId) return; // Can't update if there's no task

    // We reuse the 'add member' mutation. The backend should handle this as an 'upsert' (update if exists, else add).
    // This is a common pattern. If your backend requires a different endpoint/method for updates, you'd create a new mutation hook.
    const assignId =
      task?.assignedUsers.find((t) => t.user.userId == member.user.userId)
        ?.taskAssignUsersId ?? "";
    updateTaskMemberMutation.mutate(
      {
        assginedToUserId: assignId,
        workingHours: workingHours,
      },
      {
        onSuccess: () => {
          // No toast needed for a quiet update, just refetch to confirm.
          refetch();
          projects.refetch();
        },
        onError: (error) => {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      }
    );
  };
  const [totalWorkHoursTask, setTotalWorkHoursTask] = useState(0);
  useEffect(() => {
    let total = 0;
    task?.assignedUsers?.forEach((e) => {
      total += e.workingHours;
    });
 
    setTotalWorkHoursTask(Math.max(total, 0));
  }, [task]);

  const [searchString, setSearchString] = useDebounce("", 400);
  const [filteredUser, setFilteredUser] = useState<UserOrganisationType[]>([]);

  useEffect(() => {
    const tempData: UserOrganisationType[] = [];
    if (searchString) {
      taskMember?.forEach((element) => {
        const searchStringLower = searchString?.toLowerCase();
        const userFirstNameLower = element.user.firstName?.toLowerCase();
        const userLastNameLower = element.user.lastName?.toLowerCase();
        const userEmail = element.user.email?.toLowerCase();
        if (
          (searchStringLower !== undefined &&
            userFirstNameLower?.includes(searchStringLower)) ||
          userLastNameLower?.includes(searchStringLower) ||
          userEmail?.includes(searchStringLower)
        ) {
          tempData.push(element);
        }
      });
      setFilteredUser(tempData ?? []);
    } else {
      setFilteredUser(taskMember);
    }
  }, [searchString, taskMember]);

  const [filteredTasks, setFilteredTasks] = useState<Task[]>([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSubtask(value);
    if (value.length > 0) {
      const matches =
        allTask.data?.data.data?.filter(
          (task) =>
            task.taskName.toLowerCase().includes(value.toLowerCase()) &&
            task.taskId !== taskId
        ) ?? [];
      setFilteredTasks(matches ?? []);
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  };

  const handleSelectTask = async (filterTask: Task) => {
    if (!taskId) {
      await createTaskWithValue();
    }
    updateTaskParentMutation.mutate(
      {
        parentTaskId: tempId ? tempId : task?.taskId,
        id: filterTask.taskId,
      },
      {
        onSuccess() {
          taskQuery.refetch();
        },
      }
    );

    setShowDropdown(false);
    setSubTaskFieldShow(false);
  };
  const createSubtasksOption = useCallback((): Task[] => {
    if (!allTask) return [];
    const allTasks = filteredTasks;
    return allTasks.filter((t) => {
      if (t.taskId === task?.taskId) return false;
      if (task?.taskId == t.parentTaskId) return false;
      return true;
    });
  }, [filteredTasks, task]);

  const leftChild = useMemo(
    () => (
      <div
        className={`flex w-full flex-col gap-2 h-full overflow-y-auto @container`}
      >
        {parentTask && (
          <div
            className="flex gap-3 items-center underline underline-offset-2 @md:text-2xl text-base text-primary-500 cursor-pointer"
            onClick={() => setTaskId(task?.parentTaskId ?? "")}
          >
            <img src={BackIcon} className="w-6 h-6" />
            {parentTask}
          </div>
        )}
        <div
          className={`flex items-center justify-between @md:flex-row flex-col @lg:gap-10 gap-2 ${
            parentTask && "pl-4"
          }`}
        >
          <div className="flex gap-2 items-center w-full">
            {/* ... (Flag and Task Name remain largely the same, adjust widths/gaps if needed at container breakpoints) ... */}
            <div className="w-7 h-7 min-w-7 ">
              <TooltipProvider delayDuration={0}>
                <Tooltip>
                  <TooltipTrigger asChild>
                    {task?.flag == "Green" ? (
                      <img
                        src={GreenFlag}
                        className="w-full p-1.5 border rounded-md border-flag-green"
                      />
                    ) : task?.flag == "Red" ? (
                      <img
                        src={RedFlag}
                        className="w-full p-1.5 border rounded-md border-flag-red"
                      />
                    ) : task?.flag == "Orange" ? (
                      <img
                        src={OrangeFlag}
                        className="w-full p-1.5 border rounded-md border-flag-red"
                      />
                    ) : (
                      ""
                    )}
                  </TooltipTrigger>
                  <TooltipContent className="!p-1.5">
                    {task?.flag == "Green"
                      ? t("ON_TIME")
                      : task?.flag == "Red"
                      ? t("SIGNIFICANT_DELAY")
                      : task?.flag == "Orange"
                      ? t("MODERATE_DELAY")
                      : ""}
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>
            <div className="flex items-center">
              <div>
                {taskNameField || !taskId ? (
                  <div>
                    <InputText
                      onBlur={(e) => {
                        if (e.relatedTarget?.id == "closeTask") return;
                        taskFormik.submitForm();
                        setTaskNameField(false);
                      }}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          taskFormik.submitForm();
                          setTaskNameField(false);
                        }
                      }}
                      name="taskName"
                      onChange={taskFormik.handleChange}
                      onClick={taskFormik.handleBlur}
                      placeholder={t("create_new_task")}
                      value={taskFormik.values.taskName}
                    ></InputText>
                    {taskFormik.values.taskName &&
                      taskFormik.errors.taskName && (
                        <ErrorMessage>
                          {" "}
                          {t(taskFormik.errors.taskName)}
                        </ErrorMessage>
                      )}
                  </div>
                ) : (
                  <div className="@md:text-4xl text-lg font-semibold text-gray-450 max-w-[20ch] truncate">
                    {taskFormik.values.taskName}
                  </div>
                )}
              </div>
              {allowed() && (
                <Button
                  variant={"none"}
                  onClick={() => setTaskNameField((prev) => !prev)}
                >
                  <img src={Edit} className="min-w-3 min-h-3" />
                </Button>
              )}
            </div>
          </div>
          {/* Members / Percentage: Might adjust layout at smaller container widths */}
          {/* Current: inline-flex w-full gap-4 justify-end */}
          {/* If needed, could add e.g., @sm:flex-col to stack in small containers */}
          <div className="inline-flex w-full gap-4 justify-end">
            <Popover>
              <PopoverTrigger
                // Disable popover trigger when not allowed or loading, this doesn't need container query
                className="ml-auto w-32 min-w-32" // w-32 min-w-32 might be too wide for small containers
                disabled={!allowed()}
              >
                {/* Consider making member avatars section responsive if needed */}
                <div
                  className={`${
                    member.length > 0 ? "w-36" : "w-36"
                  } flex justify-end items-center`}
                >
                  {member?.slice(0, 4).map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={`${index > 0 ? "-ml-4" : ""}`} // Adjust overlap with negative margin-left
                      >
                        <UserAvatar
                          className="shadow-sm shadow-gray-300 border-2 border-white"
                          user={item}
                        />
                      </div>
                    );
                  })}
                  {allowed() && (
                    <div className="flex items-center gap-2 -ml-4 mr-1">
                      {" "}
                      {member?.length == 0 && (
                        <div className="text-xs whitespace-nowrap">
                          {t("assign_member")}
                        </div>
                      )}
                      <div className="rounded-full bg-primary-500 flex items-center justify-center min-w-8 h-8 w-8 z-10">
                        <img src={NoramlPlus} className="w-2.5 h-2.5" />
                      </div>
                    </div>
                  )}
                </div>
              </PopoverTrigger>
              {/* Popover Content layout is already okay */}
              <PopoverContent className="w-fit focus:outline-none h-1/2">
                <div className="grid gap-1">
                  <div className="space-y-2 flex gap-2 items-center justify-between">
                    <h4 className="font-medium leading-none">{t("members")}</h4>
                    {!task?.subtasks?.length && !task?.milestoneIndicator && (
                      <div className="text-sm text-gray-400 mr-8">
                        {t("Total work hours for this task")}
                        {": "}
                        <span className="font-semibold">
                          {totalWorkHoursTask}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="w-full justify-end flex items-center">
                    <InputText
                      onChange={(e) => setSearchString(e.target.value)}
                      className="my-2 h-10"
                      placeholder={t("filter_by_name_and_email")}
                    />
                  </div>
                  <div className="max-h-64 overflow-auto">
                    {/* 4. Replace the old mapping logic with the new component */}
                    {filteredUser.map((memberData) => {
                      const assignedInfo = task?.assignedUsers?.find(
                        (u) => u.user.userId === memberData.user.userId
                      );
                      const isAssigned = !!assignedInfo;

                      return (
                        <MemberAssignmentItem
                          task={task as Task}
                          key={
                            memberData.user.userId + task?.duration + isAssigned
                          }
                          member={memberData}
                          assignedInfo={assignedInfo as any}
                          isAssigned={isAssigned}
                          taskDuration={task?.duration ?? 1}
                          onToggleAssign={handleToggleMember}
                          onUpdateAssign={handleUpdateMemberAssignment}
                        />
                      );
                    })}
                  </div>
                  {
                    <div className="flex w-full justify-end truncate">
                      <Link
                        to={`/members/${props.projectId}`}
                        className="text-xs w-fit  my-3 truncate
 underline text-primary-500  text-right"
                      >
                        {t("Add more members to your project")}
                      </Link>
                    </div>
                  }
                </div>
              </PopoverContent>
            </Popover>
            {/* Percentage circle - typically okay as a fixed size item */}
            {!isNaN(Number(task?.completionPecentage)) && (
              <div>
                <PercentageCircle
                  className="text-sm"
                  percentage={task?.completionPecentage ?? 0}
                  roundColor={`${
                    task?.flag == "Green"
                      ? "#68B266"
                      : task?.flag == "Red"
                      ? "#EA4335"
                      : task?.flag == "Orange"
                      ? "#FFA500"
                      : ""
                  } `}
                />
              </div>
            )}
          </div>
        </div>
        {/* Milestone / Progress / Status - Use @container queries */}
        {/* Change md:flex-row to @md:flex-row */}
        <div className="flex flex-col @container @md:flex-row items-center justify-between gap-2.5">
          {/* Milestone/Progress section */}
          <div
            className={`border border-gray-450/30 px-2.5 h-9 rounded-md flex items-center gap-2.5 ${
              // Adjust width based on container breakpoint if needed
              !milestoneFormik.values.milestoneIndicator
                ? "w-full @md:w-full"
                : "w-fit @md:w-fit"
            }`}
          >
            {/* ... (Milestone checkbox and label) ... */}
            <div className="w-1/2 flex items-center gap-2">
              <input
                type="checkbox"
                className="accent-primary-300"
                disabled={Boolean(task?.subtasks?.length) || !allowed()}
                checked={milestoneFormik.values.milestoneIndicator}
                onClick={() => {
                  {
                    milestoneHandlechange(
                      !milestoneFormik.values.milestoneIndicator
                    );
                    milestoneFormik.submitForm();
                  }
                }}
              />{" "}
              <label className="text-gray-450">{t("milestone")}</label>
            </div>
            {/* Progress / Completed status */}
            <div className="w-1/2 flex  items-center gap-2.5">
              <div className="text-xs text-gray-450">
                {!milestoneFormik.values.milestoneIndicator
                  ? t("Progress")
                  : t("Completed")}
              </div>
              {!milestoneFormik.values.milestoneIndicator ? (
                <div className="flex w-full items-center gap-1">
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <div className="w-full  ">
                          {" "}
                          {/* This w-full is relative to its flex item parent */}
                          <Slider
                            key={
                              taskQuery.isFetching +
                              "" +
                              task?.completionPecentage
                            }
                            className="!w-full my-5"
                            defaultValue={[
                              !task ? 0 : Number(task.completionPecentage),
                            ]}
                            max={100}
                            disabled={
                              Boolean(task?.subtasks?.length) ||
                              task?.milestoneIndicator ||
                              !allowed()
                            }
                            min={0}
                            title={task?.completionPecentage}
                            onValueChange={(e) => {
                              setSlider(e[0]);
                            }}
                            onValueCommit={(e) => {
                              onProgressUpdate(e);
                              setTask((prev) => {
                                if (!prev) return prev;

                                return {
                                  ...prev,
                                  completionPecentage: String(e[0] ?? 0),
                                };
                              });
                            }}
                          />
                        </div>
                      </TooltipTrigger>

                      <TooltipContent
                        className="z-50 bg-white p-2 rounded-md shadow-md"
                        style={{
                          display:
                            task && task?.subtasks?.length > 0 ? " " : "none",
                        }}
                      >
                        {task && task?.subtasks?.length > 0 && (
                          <p className="text-sm w-72">
                            {t("task_disabled_filed_tool")}
                          </p>
                        )}
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>

                  <div className="flex gap-2 items-center">
                    <div
                      key={task?.completionPecentage}
                      className="text-xs font-medium text-gray-400 flex items-center gap-2"
                    >
                      {slider ? Number(slider).toFixed() + "%" : "0%"}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="flex justify-between items-center gap-2.5">
                  {" "}
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      name="todayDays"
                      checked={task?.status == TaskStatusEnumValue.COMPLETED}
                      className="sr-only peer"
                      onChange={(e) => {
                        if (e.target.checked) {
                          updateStatus(TaskStatusEnumValue.COMPLETED);
                        } else {
                          updateStatus(TaskStatusEnumValue.NOT_STARTED);
                        }
                      }}
                    />
                    <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary-600 dark:peer-focus:ring-primary-400 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-primary-400"></div>
                  </label>
                </div>
              )}
              {/* Error message positioning might need tweaking */}
              {progressError && (
                <ErrorMessage className="w-1/2">{progressError}</ErrorMessage>
              )}
            </div>
          </div>
          {/* Status Dropdown - width might need adjustment at container breakpoints */}
          <div>
            <DropdownMenu>
              <DropdownMenuTrigger
                asChild
                disabled={!allowed() || Boolean(task?.subtasks?.length)}
              >
                <div className="text-sm font-normal cursor-pointer">
                  <Button
                    disabled={!allowed() || Boolean(task?.subtasks?.length)}
                    variant={"secondary"}
                    // Apply w-full by default, let it shrink in the flex container,
                    // or specify responsive width like w-full @md:w-auto
                    className="py-1 h-9 px-3 flex w-full gap-3 justify-start bg-gray-450 text-white hover:bg-gray-450/80"
                  >
                    {task?.status
                      ? `${t("status")}: ${t(task?.status)}`
                      : t("select_status")}
                  </Button>
                </div>
              </DropdownMenuTrigger>
              {/* Dropdown menu content is fine as w-auto */}
              <DropdownMenuContent className="w-auto">
                {taskStatus().map((status) => {
                  return (
                    <div
                      onClick={() => {
                        updateStatus(status);
                      }}
                      className="cursor-pointer flex px-3 w-44 rounded-md hover:bg-slate-50/80 py-2 justify-between items-center"
                    >
                      {t(status)}
                      <CheckIcon
                        className={cn(
                          "ml-auto h-4 w-4",
                          status === task?.status ? "opacity-100" : "opacity-0"
                        )}
                      />
                    </div>
                  );
                })}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
        {/* Description - w-full is okay */}
        <div className="w-full">
          <textarea
            disabled={!allowed()}
            name="taskDescription"
            className="w-full border rounded-md px-2 resize-none"
            onBlur={async (e) => {
              if (!taskFormik.errors.taskDescription) {
                if (!taskId && e.target.value) {
                  await createTaskWithValue({
                    taskDescription: e.target.value ?? "",
                  });
                }
                if (e.target.value) {
                  taskFormik.submitForm();
                }
              }
            }}
            onChange={taskFormik.handleChange}
            value={taskFormik.values.taskDescription}
            placeholder={t("Description")}
            cols={30}
            rows={4}
          ></textarea>
          {taskFormik.errors.taskDescription && (
            <ErrorMessage className="w-1/2">
              {" "}
              {/* w-1/2 here might also be relative to container width if parent is flex/grid */}
              {t(taskFormik.errors.taskDescription)}
            </ErrorMessage>
          )}
        </div>
        {/* Date / Duration / End Date Grid - Use @container queries */}
        {/* Change md:grid-cols-3 and grid-cols-1 to container breakpoints */}
        {/* Add a breakpoint for 2 columns like @sm:grid-cols-2 if desired */}
        <div className="grid grid-cols-1 @container @md:grid-cols-2 @lg:grid-cols-3 gap-5">
          <div className="mt-2 w-full">
            {" "}
            {/* w-full is fine inside grid item */}
            {(task?.subtasks?.length == 0 || !task) && (
              <Popover>
                <PopoverTrigger
                  className="w-full"
                  disabled={!allowed() || (task && task?.subtasks?.length > 0)}
                >
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <Button
                          variant={"none"}
                          className="border px-1.5 h-8 rounded-md w-full"
                          disabled={
                            !allowed() || (task && task?.subtasks?.length > 0)
                          }
                        >
                          <div className="flex w-full gap-3 justify-start">
                            <img src={CalendarIcon} className="w-4" />
                            <div>
                              {t("start_date")}
                              <span className="text-red-500 text-sm">*</span>
                            </div>
                            <div className="text-gray-400 text-sm">
                              {dateFormater(
                                new Date(
                                  taskFormik.values.startDate ?? startDate
                                )
                              )}
                            </div>
                          </div>
                        </Button>
                      </TooltipTrigger>
                      <TooltipContent>
                        {task && task?.subtasks?.length > 0 && (
                          <p className="text-sm w-72">
                            {" "}
                            {t("task_disabled_filed_tool")}
                          </p>
                        )}
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </PopoverTrigger>
                {/* Popover content calendar is fine */}
                <PopoverContent
                  className="p-0 "
                  onCloseAutoFocus={() =>
                    taskId ? taskFormik.submitForm() : ""
                  }
                >
                  <Calendar
                    mode="single"
                    fromYear={2020}
                    toYear={2300}
                    captionLayout="dropdown-buttons"
                    selected={getSelectedDate()}
                    onSelect={async (e) => {
                      {
                        const startDate = UTCDateConverter(new Date(e ?? ""));
                        if (!taskId) {
                          await createTaskWithValue({
                            startDate: startDate,
                          });
                        }
                        taskFormik.setFieldValue("startDate", startDate);
                        setUpdateDate(startDate);
                      }
                    }}
                    className="rounded-md border"
                    defaultMonth={UTCDateConverter(
                      task?.startDate ? new Date(task?.startDate) : new Date()
                    )}
                    disabled={[
                      {
                        dayOfWeek: nonWorkingDays(),
                      },
                      {
                        before: startDate,
                      },
                      ...(holiday ?? []),
                    ]}
                  />
                  {taskFormik.errors.startDate &&
                    taskFormik.values.startDate && (
                      <ErrorMessage className="ml-0 p-0"></ErrorMessage>
                    )}
                </PopoverContent>
              </Popover>
            )}
            {task && task?.subtasks?.length > 0 && (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger
                    asChild
                    className="border px-1.5 py-2 h-8 rounded-md w-full opacity-50"
                  >
                    <div className="flex w-full gap-1 justify-start">
                      <img src={CalendarIcon} className="w-4 " />
                      <div className="text-xs">
                        {t("start_date")}
                        <span className="text-red-500 text-sm">*</span>
                      </div>
                      <div className="text-gray-400 text-sm">
                        {dateFormater(
                          new Date(taskFormik.values.startDate ?? startDate)
                        )}
                      </div>
                      <div className="ml-auto">
                        <img
                          src={InfoCircle}
                          className="h-[16px] w-[16px]"
                          alt="InfoCircle"
                        />
                      </div>
                    </div>
                  </TooltipTrigger>
                  <TooltipContent>
                    {task && task?.subtasks?.length > 0 && (
                      <p className="text-sm w-72">
                        {" "}
                        {t("task_disabled_filed_tool")}
                      </p>
                    )}
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
          </div>
          <div className="mt-2" key={taskId}>
            {" "}
            {/* w-full is fine inside grid item */}
            {(task?.subtasks?.length == 0 || !task) && (
              <div className="flex flex-col">
                {!taskDurationField && (
                  <div className="flex gap-5">
                    <Button
                      variant={"none"}
                      onClick={() =>
                        task?.subtasks?.length == 0 || !task
                          ? setTaskDurationField((prev) => !prev)
                          : ""
                      }
                      disabled={task?.milestoneIndicator || !allowed()}
                      className="w-full flex justify-between border px-1.5 py-2 h-8 rounded-md"
                    >
                      <div className="text-xs font-medium text-gray-400 flex gap-2 ">
                        <div>
                          {t("Duration")}:
                          <span className="text-red-500 text-sm">*</span>
                        </div>
                        <div className="text-sm  text-gray-300">
                          {taskFormik.values.duration ?? 0.0} {t("Day")}
                        </div>
                      </div>

                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <img
                              src={InfoCircle}
                              className="h-[16px] w-[16px]"
                              alt="InfoCircle"
                            />
                          </TooltipTrigger>
                          <TooltipContent className="">
                            <p className="text-sm w-72 text-wrap">
                              {t("duration_description")}
                            </p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                    </Button>
                  </div>
                )}
                {taskDurationField && (
                  <div className="flex items-center gap-2.5 w-full ">
                    {" "}
                    {/* w-full is fine here */}
                    <div>
                      <InputNumber
                        onBlur={async (e) => {
                          if (Number(e.target.value)) {
                            if (!taskId) {
                              await createTaskWithValue({
                                duration: Number(e.target.value),
                              });
                            }
                            taskFormik.submitForm();
                          }
                          setTaskDurationField(false);
                        }}
                        autoFocus
                        name="duration"
                        onChange={async (e) => {
                          taskFormik.handleChange(e);
                        }}
                        onClick={taskFormik.handleBlur}
                        value={taskFormik.values.duration}
                        className="!h-8"
                      ></InputNumber>
                    </div>
                  </div>
                )}
              </div>
            )}
            {task && task?.subtasks?.length > 0 && (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div className="flex gap-5 opacity-50">
                      <div className="w-full flex justify-between border px-1.5 py-2 h-8 rounded-md">
                        <div className="text-xs font-medium text-gray-400 flex gap-2 ">
                          <div>
                            {t("Duration")}:{" "}
                            <span className="text-red-500 text-sm">*</span>
                          </div>
                          <div className="text-sm  text-gray-300">
                            {taskFormik.values.duration ?? 0.0} Day
                          </div>
                        </div>

                        <div className="flex items-center justify-end relative">
                          <img
                            src={InfoCircle}
                            className="h-[16px] w-[16px]"
                            alt="InfoCircle"
                          />
                        </div>
                      </div>
                    </div>
                  </TooltipTrigger>
                  <TooltipContent>
                    {task && task?.subtasks?.length > 0 && (
                      <p className="text-sm w-72 ">
                        {t("task_disabled_filed_tool")}
                      </p>
                    )}
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
          </div>
          <div className="mt-2">
            {" "}
            {/* w-full is fine inside grid item */}
            {/* <Button
              variant={"none"}
              className="border px-1.5 py-2 h-8 rounded-md w-full opacity-50"
              disabled={!allowed()}
            >
              <div className="flex w-full gap-3 justify-start">
                <img src={CalendarIcon} className="w-3.5" />
                <div>
                  {t("")}
                  <span className="text-red-500 text-sm">*</span>
                </div>
                <div className="text-gray-400 text-sm">
                  {tasks?.endDate
                    ? dateFormater(new Date(tasks.endDate))
                    : ""}
                </div>
              </div>
            </Button> */}
            {(task?.subtasks?.length == 0 || !task) && (
              <Popover>
                <PopoverTrigger
                  className="w-full"
                  disabled={!allowed() || (task && task?.subtasks?.length > 0)}
                >
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <Button
                          variant={"none"}
                          className="border px-1.5 py-2 h-8 rounded-md w-full"
                          disabled={
                            !allowed() || (task && task?.subtasks?.length > 0)
                          }
                        >
                          <div className="flex w-full gap-3 justify-start">
                            <img src={CalendarIcon} className="w-4" />
                            <div>
                              {t("end_date")}
                              <span className="text-red-500 text-sm">*</span>
                            </div>
                            <div className="text-gray-400 text-sm">
                              {taskId
                                ? dateFormater(endDate ?? getSelectedDate())
                                : dateFormater(
                                    new Date(
                                      new Date(
                                        taskFormik.values.startDate ??
                                          getSelectedDate()
                                      ).setDate(
                                        new Date(
                                          taskFormik.values.startDate ??
                                            getSelectedDate()
                                        ).getDate() +
                                          Number(taskFormik.values.duration)
                                      )
                                    )
                                  )}
                            </div>
                          </div>
                        </Button>
                      </TooltipTrigger>
                      <TooltipContent>
                        {task && task?.subtasks?.length > 0 && (
                          <p className="text-sm w-72">
                            {" "}
                            {t("task_disabled_filed_tool")}
                          </p>
                        )}
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </PopoverTrigger>
                <PopoverContent
                  className="p-0"
                  onCloseAutoFocus={() =>
                    taskId ? taskFormik.submitForm() : ""
                  }
                  side="bottom"
                >
                  <Calendar
                    fromYear={2020}
                    toYear={2300}
                    captionLayout="dropdown-buttons"
                    mode="single"
                    selected={endDate ?? getSelectedDate()}
                    defaultMonth={UTCDateConverter(
                      task?.endDate ? new Date(task?.endDate) : new Date()
                    )}
                    onSelect={async (e) => {
                      {
                        if (e) {
                          const startDate = UTCDateConverter(
                            new Date(taskFormik.values.startDate)
                          );
                          const endDate = UTCDateConverter(new Date(e));
                          const duration = calculateDurations(
                            startDate,
                            endDate
                          );
                          setEndDate(e);
                          if (!taskId) {
                            await createTaskWithValue({
                              duration: duration,
                            });
                          }
                          taskFormik.setFieldValue("duration", duration);
                        } else {
                          if (!taskId) {
                            await createTaskWithValue({
                              duration: 1,
                            });
                          }
                        }
                      }
                    }}
                    className="rounded-md border h-full"
                    disabled={[
                      {
                        dayOfWeek: nonWorkingDays(),
                      },
                      {
                        before: new Date(taskFormik.values.startDate),
                      },
                      ...(holiday ?? []),
                    ]}
                  />
                  {/* {taskFormik.errors.startDate &&
                    taskFormik.values.startDate && (
                      <ErrorMessage className="ml-0 p-0"></ErrorMessage>
                    )} */}
                </PopoverContent>
              </Popover>
            )}
            {task && task?.subtasks?.length > 0 && (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger
                    asChild
                    className="border px-1.5 py-2 h-8 rounded-md w-full opacity-50"
                  >
                    <div className="flex w-full gap-1 justify-start">
                      <img src={CalendarIcon} className="w-4 " />
                      <div className="text-xs">
                        {t("end_date")}
                        <span className="text-red-500 text-sm">*</span>
                      </div>
                      <div className="text-gray-400 text-sm">
                        {dateFormater(new Date(endDate ?? getSelectedDate()))}
                      </div>
                      <div className="ml-auto">
                        <img
                          src={InfoCircle}
                          className="h-[16px] w-[16px]"
                          alt="InfoCircle"
                        />
                      </div>
                    </div>
                  </TooltipTrigger>
                  <TooltipContent>
                    {task && task?.subtasks?.length > 0 && (
                      <p className="text-sm w-72">
                        {" "}
                        {t("task_disabled_filed_tool")}
                      </p>
                    )}
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
          </div>
        </div>

        {/* Sub-tasks and Attachments Grid - Use @container queries */}
        {/* Change md:grid-cols-2 to @md:grid-cols-2 */}
        <div className="grid grid-cols-1 @container @md:grid-cols-2 gap-x-3 gap-y-0">
          <div className="w-full">
            {" "}
            {/* w-full is fine in grid item */}
            <div>
              <div
                className={` flex items-center justify-between gap-2.5 border px-1.5 py-2 h-8 rounded-md ${
                  task?.milestoneIndicator && "opacity-75 bg-gray-400/5"
                }`}
              >
                {!subTaskFieldShow && (
                  <div className="flex items-center">
                    <img src={ParentTaskIcon} className="w-4 h-4 mr-1" />
                    <div className="text-sm font-medium text-nowrap">
                      {t("Sub-tasks")}
                    </div>
                  </div>
                )}
                <div className="w-full flex items-center">
                  {subTaskFieldShow && (
                    <>
                      <div className="relative flex w-full">
                        <img
                          src={ParentTaskIcon}
                          className="w-4 h-4 mr-1 absolute left-0 top-1/2 -translate-y-1/2"
                        />
                        <div className="relative w-full">
                          <InputText
                            name="taskName"
                            placeholder="What needs to be done?"
                            onChange={handleInputChange}
                            value={subTask}
                            autoFocus
                            onKeyDown={(e) => {
                              e.key === "Enter" && subTask.length < 250
                                ? createSubTask()
                                : "";
                            }}
                            className="!h-9 w-5/6 px-5 m-0 border border-l-0 border-r-0 relative rounded-none border-opacity-75 focus:!outline-none placeholder:text-sm"
                          />

                          {showDropdown && filteredTasks.length > 0 && (
                            <ul className="absolute z-10 w-5/6 bg-white border border-gray-300 border-t-0 max-h-48 overflow-y-auto shadow-md">
                              {createSubtasksOption().map((task, idx) => (
                                <li
                                  key={idx}
                                  className="px-4 py-2 cursor-pointer hover:bg-gray-100 text-sm"
                                  onClick={() => handleSelectTask(task)}
                                >
                                  {task.taskName}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>

                        <Button
                          variant={"none"}
                          onClick={() => {
                            setSubTaskFieldShow(false), setSubtask("");
                          }}
                          className="p-0 absolute right-7"
                        >
                          <img
                            src={Close}
                            className="brightness-0 w-2 h-2"
                            width={20}
                            height={20}
                          />
                        </Button>
                        <Button
                          variant={"none"}
                          onClick={createSubTask}
                          className="p-0 absolute right-0"
                          disabled={Boolean(!subTask) || subTask.length > 250}
                        >
                          <img
                            src={PlusSvg}
                            className="brightness-0 w-4 h-4"
                            width={20}
                            height={20}
                          />
                        </Button>
                      </div>
                    </>
                  )}
                </div>
                {!subTaskFieldShow && allowed() && (
                  <Button
                    variant={"none"}
                    className="h-fit w-fit p-0"
                    disabled={task?.milestoneIndicator}
                    onClick={() => {
                      setSubTaskFieldShow((prev) => (prev = !prev));
                    }}
                  >
                    <img
                      src={PlusSvg}
                      className="brightness-0 min-w-4 min-h-4"
                      width={20}
                      height={20}
                    />
                  </Button>
                )}
              </div>
              {subTask.length > 250 && (
                <ErrorMessage>{t("character limit exceeded")}</ErrorMessage>
              )}
              <div className="max-h-52 mt-3 overflow-auto">
                {task &&
                  task.subtasks
                    ?.slice(0, showAllSubTitle ? task.subtasks?.length : 5)
                    .map((task, index) => {
                      return (
                        <div
                          className="w-full flex justify-between items-center lex mt-2 h-7 px-2 rounded-md !bg-primary-50"
                          key={index}
                        >
                          <div
                            className="w-full truncate cursor-pointer"
                            onClick={() => setTaskId(task.taskId)}
                          >
                            <div className="flex gap-2 w-full">
                              <p className="text-sm font-normal underline truncate w-full text-left">
                                {task.taskName}
                              </p>
                            </div>
                          </div>
                          {allowed() && (
                            <div>
                              <img
                                src={TrashCan}
                                className="cursor-pointer w-4 min-w-4"
                                onClick={() =>
                                  setShowConfirmDelete(task.taskId)
                                }
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                {task &&
                task?.subtasks?.length &&
                task?.subtasks?.length > 5 ? (
                  <div
                    className="text-end text-xs mt-2 cursor-pointer text-primary-500"
                    onClick={() => setShowAllSubTitle((prev) => !prev)}
                  >
                    {!showAllSubTitle ? t("view_more") : ""}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div>
            {" "}
            {/* w-full is fine in grid item */}
            <div className="flex items-center justify-between gap-2.5 border px-1.5 py-2 h-8 rounded-md">
              <input
                type="file"
                ref={fileInput}
                onChange={(e) => fileUpload(e)}
                className="hidden"
                multiple
              />
              <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger
                  className="ml-auto w-full"
                  disabled={attachmentUploading || !allowed()}
                >
                  <div className="w-full flex justify-between items-center">
                    <div className="flex items-center">
                      <img src={PapperClip} className="w-4 h-4 mr-1" />
                      <div className="text-sm font-medium text-nowrap flex items-center gap-2">
                        {t("attachment")}
                        {attachmentUploading && (
                          <div>
                            <Loader2Icon
                              className="animate-spin w-4"
                              color="#808080"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    {allowed() && (
                      <img
                        src={PlusSvg}
                        className="brightness-0 w-4 h-4"
                        width={20}
                        height={20}
                      />
                    )}
                  </div>
                </PopoverTrigger>
                <PopoverContent className="focus:outline-none">
                  <div className="grid gap-4">
                    <Button
                      variant={"none"}
                      className="h-fit w-fit p-0 text-primary-500 flex gap-1 items-center"
                      onClick={() => fileInput.current?.click()}
                      isLoading={attachmentUploading}
                      disabled={attachmentUploading || !allowed()}
                    >
                      <img src={DesktopSvg} className="w-4 h-4 mr-1" />
                      {t("From computer")}
                    </Button>
                    <Button
                      variant={"none"}
                      className="h-fit w-fit p-0 text-primary-500 flex gap-1 items-center"
                      onClick={openPicker}
                    >
                      <img src={DropboxSvg} className="w-4 h-4 mr-1" />
                      {t("From dropbox")}
                    </Button>
                  </div>
                </PopoverContent>
              </Popover>
            </div>
            {task?.documentAttachments &&
            task?.documentAttachments.length > 0 ? (
              <TaskAttachment
                refetch={refetch}
                task={task}
                allowed={allowed()}
              ></TaskAttachment>
            ) : (
              ""
            )}
          </div>
          {/* Task Dependencies - Use @container query for col-span */}
          {/* Change md:col-span-2 to @md:col-span-2 */}
          <div className="w-full col-span-1 @container @md:col-span-2">
            {" "}
            {/* w-full is fine, col-span-1 is default */}
            <TaskDependencies
              projectId={props.projectId}
              task={task}
              refetch={refetch}
              allowed={allowed()}
              setTaskId={(id: string) => setTaskId(id)}
              setTask={(task: Task) => setTask(task)}
              allTask={allTask.data?.data.data ?? []}
            />
          </div>
        </div>
      </div>
    ),
    [
      // Keep all dependencies as they are
      allTask.data?.data.data,
      allowed,
      attachmentUploading,
      calculateDurations,
      createSubTask,
      createTaskWithValue,
      endDate,
      fileUpload,
      getSelectedDate,
      handleToggleMember,
      holiday,
      member,
      milestoneFormik,
      milestoneHandlechange,
      nonWorkingDays,
      onProgressUpdate,
      parentTask,
      progressError,
      props.projectId,
      refetch,
      showAllSubTitle,
      slider,
      startDate,
      subTask,
      subTaskFieldShow,
      t,
      task,
      taskAddMembersMutation.isPending,
      taskDurationField,
      taskFormik,
      taskId,
      taskMemberList.data?.data.data,
      taskMemberList.isFetching,
      taskMemberList.isRefetching,
      taskNameField,
      taskQuery.isFetching,
      taskRemoveMembersMutation.isPending,
      taskStatus,
      updateStatus,
    ]
  );
  const rightChild = useMemo(
    () => (
      <div className={`h-full  bg-white w-[97%] ml-2`}>
        <div className="flex justify-between">
          <div className="flex items-center gap-2.5 mt-4">
            <img src={ScaleSvg} className="w-4 h-4" />
            <div>
              <div className="text-xl font-medium">{t("activity")}</div>
            </div>
          </div>
          <div className="md:block hidden">
            <Button variant={"none"} id="closeTask" onClick={close}>
              <img src={Close} className="h-4 w-4 " />
            </Button>
          </div>
        </div>
        <TaskComment
          projectId={props.projectId}
          setTask={setTask}
          setTaskId={setTaskId}
          task={task}
          refetch={refetch}
          allowed={allowed()}
        ></TaskComment>
        {task?.histories && task.histories.length > 0 && (
          <TaskHistory task={task} />
        )}
      </div>
    ),
    [allowed, close, props.projectId, refetch, t, task]
  );
  return (
    <Dialog
      isOpen
      onClose={() => {
        taskId ? allTask.refetch() : close();
      }}
      modalClass="w-fit h-fit md:w-[85%] md:max-h-[90%] md:min-h-[80%] flex  bg-white rounded-md md:p-8 p-2 "
      key={taskId}
    >
      {(taskQuery.isFetching ||
        taskQuery.isRefetching ||
        taskCreateMutation.isPaused) && (
        <Loader className="absolute top-0 left-0  z-50" />
      )}

      <div className="md:hidden flex justify-end">
        <Button variant={"none"} onClick={close} className="ml-auto">
          <img src={Close} className="h-4 w-4 " />
        </Button>
      </div>
      <div className="flex gap-2 md:flex-row flex-col w-full  !min-h-full">
        <OverlaySlider
          initialOverlayWidth="25%"
          sliderWidth={4}
          sliderColor="#6b728044"
          overlayBgColor="white"
          overlayShadow="none"
          zIndexBase={50}
        >
          {leftChild}
          {rightChild}
        </OverlaySlider>

        {invalidDate && errorMessage && (
          <Dialog
            isOpen={invalidDate}
            onClose={() => {}}
            modalClass="rounded-lg"
          >
            <div className="flex flex-col gap-2 p-6 ">
              <img src={TrashCan} className="w-12 m-auto" /> {errorMessage}
              <div className="flex gap-2 ml-auto">
                <Button
                  variant={"outline"}
                  onClick={() => setInvalidDate(false)}
                  isLoading={removeTaskDependenciesMutation.isPending}
                  disabled={removeTaskDependenciesMutation.isPending}
                >
                  {t("cancel")}
                </Button>
                <Button
                  variant={"primary"}
                  onClick={() => {
                    setInvalidDate(false);
                    deleteDependenciesId();
                  }}
                >
                  {t("delete")}
                </Button>
              </div>
            </div>
          </Dialog>
        )}
        <Dialog
          isOpen={scheduledError}
          onClose={() => {}}
          modalClass="rounded-lg w-1/3"
        >
          <div className="flex flex-col gap-2 p-6 ">
            <img src={YallowInfoIcon} className="w-12 m-auto" />{" "}
            <div dangerouslySetInnerHTML={{ __html: t("futureTaskWarning") }} />
            <div className="flex gap-2 ml-auto">
              <Button
                variant={"primary"}
                onClick={() => {
                  setScheduledError(false);
                  setTask((prev) => {
                    if (!prev) return prev;
                    return {
                      ...prev,
                      completionPecentage: String(
                        taskQuery.data?.data.data.completionPecentage
                      ),
                    };
                  });
                }}
              >
                {t("ok")}
              </Button>
            </div>
          </div>
        </Dialog>
        <Dialog
          isOpen={Boolean(showConfirmDelete)}
          onClose={() => {}}
          modalClass="rounded-lg"
        >
          <div className="flex flex-col gap-2 p-6 ">
            <img src={TrashCan} className="w-12 m-auto" />{" "}
            {t("common_delete_message")}
            <div className="flex gap-2 ml-auto">
              <Button
                variant={"outline"}
                isLoading={removeTaskMutation.isPending}
                disabled={removeTaskMutation.isPending}
                onClick={() => setShowConfirmDelete(null)}
              >
                {t("cancel")}
              </Button>
              <Button
                variant={"primary"}
                onClick={removeTask}
                isLoading={removeTaskMutation.isPending}
                disabled={removeTaskMutation.isPending}
              >
                {t("delete")}
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
    </Dialog>
  );
}

export default memo(TaskSubTaskForm);
